import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-black text-white py-10 mt-20">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Brand Info */}
                <div>
                    <h2 className="text-2xl font-bold mb-2">Emura Group<sup>®</sup></h2>
                    <p className="text-gray-400 text-sm">
                        Empowering digital transformation through innovative business solutions.
                    </p>
                </div>

                {/* Navigation */}
                <div>
                    <h3 className="font-semibold mb-3">Quick Links</h3>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/" className="hover:text-blue-400">Home</Link></li>
                        <li><Link to="/our-mission" className="hover:text-blue-400">Our Goal</Link></li>
                        <li><Link to="/our-services" className="hover:text-blue-400">Solutions</Link></li>
                        <li><Link to="/contact" className="hover:text-blue-400">Contact</Link></li>
                    </ul>
                </div>

                {/* Social or Contact */}
                <div>
                    <h3 className="font-semibold mb-3">Connect With Us</h3>
                    <div className="flex space-x-4">
                        <a href="#" className="hover:text-blue-400">🌐</a>
                        <a href="#" className="hover:text-blue-400">🐦</a>
                        <a href="#" className="hover:text-blue-400">📘</a>
                        <a href="#" className="hover:text-blue-400">📸</a>
                    </div>
                    <p className="mt-4 text-sm text-gray-400">Email: contact@emura-group.company</p>
                </div>
            </div>

            <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-500 text-sm">
                © {new Date().getFullYear()} Emura Group. All rights reserved.
            </div>
        </footer>
    );
}
